import type { ReactNode } from "react";
import CountUp from "react-countup";

import { Card } from "./card";

type StatCardProps = {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: ReactNode;
  valueClassName?: string;
  iconClassName?: string;
  status?: string;
  statusClassName?: string;
};

export function StatCard({
  title,
  value,
  subtitle,
  icon,
  valueClassName = "text-white",
  iconClassName = "bg-slate-800 text-slate-300",
  status,
  statusClassName = "bg-slate-800 text-slate-300",
}: StatCardProps) {
  return (
    <Card className="group relative overflow-hidden p-5 transition duration-200 hover:-translate-y-0.5 hover:border-slate-700 hover:bg-slate-900/95">
      <div className="flex items-start justify-between gap-5">
        <div className="min-w-0">
          <p className="text-sm font-medium text-slate-400">{title}</p>

          <p className={`mt-3 text-4xl font-bold tracking-tight ${valueClassName}`}>
            {typeof value === "number" ? (
              <CountUp end={value} duration={0.9} separator="," />
            ) : (
              value
            )}
          </p>

          <div className="mt-3 flex flex-wrap items-center gap-2">
            {subtitle && (
              <p className="text-sm text-slate-500">{subtitle}</p>
            )}

            {status && (
              <span
                className={`rounded-full px-2.5 py-1 text-xs font-semibold ${statusClassName}`}
              >
                {status}
              </span>
            )}
          </div>
        </div>

        {icon && (
          <div
            className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl ${iconClassName}`}
          >
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
}